import { Address } from './Address';

export class DigitalAddress extends Address {}
